<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <tenants-grid [hidden]="!showGrid" [workspace]="this"></tenants-grid>
    <tenants-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                 [workspace]="this"
                 [showPrevBtn]="previousButtonEnabled"
                 [showNextBtn]="nextButtonEnabled"
                 (showPrevious)="showPrevious()"
                 (showNext)="showNext()">
  </tenants-form>
  </div>
</div>
